// extracted by mini-css-extract-plugin
export default {"container":"EditProcess_container__MGJP9","action":"EditProcess_action__q7KEN"};